<template>
  <div>
    <div class="video-tools" style="background: #409eff">
      <ul>
        <li>
          <el-tooltip placement="top">
            <div slot="content">关闭所有</div>
            <div class="type">
              <img
                style="height: 20px; width: 20px"
                src="@/assets/images/closeAll.png"
                alt=""
                @click="closeAll"
              />
            </div>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip placement="top" class="type">
            <div slot="content">关闭选中单元格</div>
            <div class="type">
              <img
                style="height: 20px; width: 20px"
                src="@/assets/images/closeOne.png"
                alt=""
                @click="closeCurCell"
              />
            </div>
          </el-tooltip>
        </li>
        <slot name="extend-tools"></slot>
        <li style="margin-left: auto">
          <el-tooltip placement="top">
            <div slot="content">16分屏</div>
            <div @click="splitScreen(16)" class="type">
              <img
                class="camera_selector"
                src="@/assets/images/8B十六分屏.png"
              />
            </div>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip placement="top">
            <div slot="content">9分屏</div>
            <div @click="splitScreen(9)" class="type">
              <img class="camera_selector" src="@/assets/images/7G九分屏.png" />
            </div>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip placement="top">
            <div slot="content">4分屏</div>
            <div @click="splitScreen(4)" class="type">
              <img class="camera_selector" src="@/assets/images/7D四分屏.png" />
            </div>
          </el-tooltip>
        </li>
        <li>
          <el-tooltip placement="top">
            <div slot="content">1分屏</div>
            <div @click="splitScreen(1)" class="type">
              <img class="camera_selector" src="@/assets/images/7A一分屏.png" />
            </div>
          </el-tooltip>
        </li>
      </ul>
    </div>

    <div class="sup-video-player">
      <div
        :class="['video-list', 'video-split-' + splitNum]"
        style="height: 538px"
      >
        <div
          v-for="n in splitNum"
          :key="n"
          @click="videoItemClick(n)"
          :class="[
            'video-item',
            'split-' + splitNum,
            'video-item-' + n,
            { active: active === n },
          ]"
        >
          <vue-player :ref="'player' + n" :id="'tc-player' + n"></vue-player>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//引入播放组件
import VuePlayer from "./VuePlayer.vue";
import axios from "axios";

export default {
  name: "",
  data() {
    return {
      splitNum: this.split,
      active: this.activeIndex,
      recorder: null,
      talkbackData: null,
      dataList: [],
    };
  },
  created() {},
  components: { VuePlayer },
  props: {
    split: {
      type: Number,
      default: 1,
    },
    activeIndex: {
      type: Number,
      default: 1,
    },
    talkback: {
      type: Boolean,
      default: false,
    },
    activeName: String,
  },
  computed: {
    currPlayer() {
      var p = this.$refs["player" + this.active];
      if (p) return p[0];
      return null;
    },
  },
  methods: {
    videoItemClick(n) {
      this.active = n;
      console.log(n);
      this.talkbackData = this.currPlayer.data;
    },
    getCurrentSplitNum() {
      return this.splitNum;
    },
    setCurrentSplitNum(inputSplitNum) {
      return (this.splitNum = inputSplitNum);
    },
    closeAll() {
      for (var i = 1; i <= 16; i++) {
        let players = this.$refs["player" + i];
        let dataStr = this.dataList[i];
        if (dataStr) {
          let data = dataStr.split("_");
          this.resetMediaPlayer(data[0], data[1]);
          players[0].close();

          let playerImg = document.querySelector("#tc-player" + i + " img");
          playerImg.style.visibility = "visible";
        }
      }
    },
    closeCurCell() {
      if (this.currPlayer) {
        this.currPlayer.close();
        let data = this.dataList[this.active].split("_");
        this.closeMediaStream(data[0], data[1]);
        this.dataList[this.active] = null;

        let playerImg = document.querySelector(
          "#tc-player" + this.active + " img"
        );
        playerImg.style.visibility = "visible";
      }
    },
    closeMediaStream(deviceId, channelId) {
      // TODO 向流媒体服务器发送关闭流请求
      axios({
        url:
          process.env.VUE_APP_MEDIA_SERVICE_BASE_API +
          "/api/play/stop/${deviceId}/${channelId}",
        method: "get",
        headers: {
          "Access-Token": this.$store.state.user.mediaServiceToken,
        },
      })
        .then((result) => {
          console.log(`设备ID: ${deviceId}  通道ID: ${channelId} 流已关闭`);
        })
        .catch((error) => {
          console.log(`设备ID: ${deviceId}  通道ID: ${channelId} 关闭失败`);
        });
    },
    splitScreen(n) {
      this.active = n === 1 ? 1 : 0;
      console.log(n);
      this.splitNum = n;
      // this.active = 1;
    },
    play(url, data) {
      console.log(url, "urllllllllll");
      this.resetMediaPlayer(this.active);
      this.dataList[this.active] = data;
      this.currPlayer.load(url, data);
      var n = (this.active + 1) % (this.splitNum + 1);
      // 顺序播放
      // this.active = n == 0 ? 1 : n;
      // let playerImg = document.querySelector(
      //   "#tc-player" + this.active + " img"
      // );
      // playerImg.style.visibility = "hidden";
      // let playerImg = document.querySelector('#tc-player' + (this.active - 1) + ' img');

      let playerImg = document.querySelector(
        "#tc-player" + this.active + " img"
      );
      playerImg.style.visibility = "hidden";
    },
    resetMediaPlayer(index) {
      if (this.dataList[index]) {
        let dataArr = this.dataList[index].split("_");
        // console.log(dataArr);
        this.closeMediaStream(dataArr[0], dataArr[1]);
        this.currPlayer.reset();
        console.log(`重置 设备ID ${dataArr[0]}_${dataArr[1]}`);
      }
    },
    playAtIndex(index, url, data) {
      this.dataList[index] = data;
      let players = this.$refs["player" + index];
      if (players && players.length > 0) {
        players[0].load(url, data);
      }
    },
    capture() {
      if (this.currPlayer) {
        this.currPlayer.screenShot();
      }
    },
    detail() {
      console.log(this.currPlayer.data);
    },
    fullscreen() {
      if (this.currPlayer) {
        this.currPlayer.fullscreen();
      }
    },
    ptzCtrl(cmd, param) {
      // 判断是否正在播放视频
      if (!this.currPlayer.status()) {
        console.warn("没有选中正在播放的设备视频!");
        return;
      }
      let params = {
        avObjName: "",
        id: this.dataList[this.active].objId,
        cmd: cmd,
        param: param,
      };
      this.$api.controlPtz(params).then((response) => {
        if (!response.success) {
          this.$message({
            message: response.info,
            type: "error",
          });
        }
      });
    },
    saveScene() {
      // 判断是否有视频正在播放
      let isPlaying = false;
      for (var i = 1; i <= this.splitNum; i++) {
        let players = this.$refs["player" + i];
        if (players && players.length > 0 && players[0].status()) {
          isPlaying = true;
          break;
        }
      }
      if (!isPlaying) {
        this.$message({
          message: "没有正在播放的视频",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      // 弹出输入框输入视图名称
      this.$prompt("请输入视图名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          if (value) {
            let details = [];
            for (var i = 1; i <= this.splitNum; i++) {
              if (this.dataList[i]) {
                details.push({
                  index: i,
                  objId: this.dataList[i].objId,
                  flvUrl: "",
                });
              }
            }
            let param = {
              name: value,
              viewInfo: {
                cut: this.splitNum,
                viewInfoDetails: details,
              },
            };
            this.$api.createUVView(param).then((response) => {
              if (response.success) {
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
                this.$emit("saveSceneSuccess");
              }
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
  },
  state: {
    count: 0,
  },
  mutations: {
    increment(state) {
      state.count++;
    },
  },
};
</script>

<style lang="scss" scoped>
.sup-video-player {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: calc(100% - 48px) 48px;
  // height: 100%;

  .video-list {
    flex: 1 1 auto;
    background: #03050c;
    display: grid;

    .video-item {
      background: black;
      border: 1px solid #091026;
      cursor: pointer;
      position: relative;
      margin: 2px;
    }

    .video-item.active {
      border: 1px solid #22b5ca;
      //box-shadow: inset 0 0 2px 2px #ffba00;
    }

    &.video-split-16 {
      grid-template-columns: repeat(4, 1fr); /* 平均分成四列 */
      grid-template-rows: repeat(4, 1fr); /* 平均分成四行 */
    }

    &.video-split-1 {
      grid-template-columns: repeat(1, 1fr); /* 平均分成四列 */
      grid-template-rows: repeat(1, 1fr); /* 平均分成四行 */
    }

    &.video-split-4 {
      grid-template-columns: repeat(2, 1fr); /* 平均分成四列 */
      grid-template-rows: repeat(2, 1fr); /* 平均分成四行 */
    }

    &.video-split-9 {
      grid-template-columns: repeat(3, 1fr); /* 平均分成四列 */
      grid-template-rows: repeat(3, 1fr); /* 平均分成四行 */
    }
  }
}

.video-tools {
  height: 40px;
  background: #95a0a0;
  // margin-top: 14px;

  ul {
    display: flex;
    list-style: none;
    padding: 0 5px;
    margin: 0;
    line-height: 24px;

    .icon {
      cursor: pointer;
    }

    li {
      margin: 0 4px;
    }

    .iconfont {
      font-size: 12px;
    }
  }
}

.type {
  cursor: pointer;
  line-height: 25px;
  text-align: center;
  width: 60px;
  height: 25px;
  //border: #dadada 1px solid;
  border-radius: 5px;
  font-size: 14px;
  color: white;
  margin-top: 14px;
}

.type:hover {
  background-color: #f5f5f5;
}

.camera_selector {
  height: 20px;
  width: 20px;
}
</style>
